export enum Granularity {
  National = "N",
  Zonal = "zonal",
}
